export default __webpack_public_path__ + "static/media/Ordzhonikidze_Grigory_Eduardovich.a010a7c9.webp";